import React from "react";

const getHydrationColor = (entry) => {
  if (!entry) return "tw-bg-gray-200";
  if (entry.completedCues && entry.completedCues.length === 3) return "tw-bg-green-500";
  if (entry.completedCues && entry.completedCues.length > 0) return "tw-bg-yellow-500";
  return "tw-bg-gray-300";
};

const MonthlyLog = ({ currentDayNumber, startDate, logData, selectedDate }) => {
  const displayDate = selectedDate ? new Date(selectedDate) : new Date();
  const year = displayDate.getFullYear();
  const month = displayDate.getMonth() + 1;
  const firstOfMonth = new Date(year, month - 1, 1);
  const lastOfMonth = new Date(year, month, 0);
  const daysInMonth = lastOfMonth.getDate();
  const startDayOfWeek = firstOfMonth.getDay(); // 0 = Sunday

  // Build a flat array of all days in the month, with padding for the first week
  const daysArray = [];
  for (let i = 0; i < startDayOfWeek; i++) {
    daysArray.push(null); // pad empty cells
  }
  for (let d = 1; d <= daysInMonth; d++) {
    daysArray.push(new Date(year, month - 1, d));
  }
  // Pad the last week to fill the grid
  while (daysArray.length % 7 !== 0) {
    daysArray.push(null);
  }

  // Helper to get log entry for a given date
  const getEntryForDate = (dateObj) => {
    if (!dateObj) return null;
    // Find day number since startDate
    const trackingStartDate = new Date(startDate);
    const diff = Math.floor((dateObj - trackingStartDate) / (1000 * 60 * 60 * 24));
    const dayKey = `Day ${diff + 1}`;
    return logData[dayKey];
  };

  return (
    <div className="monthly-log tw-bg-white dark:tw-bg-black tw-p-6 tw-rounded-2xl tw-shadow-sm">
      <h2 className="tw-font-semibold tw-mb-4 tw-flex tw-justify-between tw-w-full dark:tw-text-white">
        <span>
          {firstOfMonth.toLocaleString("default", { month: "long" })} {year}
        </span>
      </h2>
      <div className="tw-grid tw-grid-cols-7 tw-gap-2 tw-items-end">
        {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((wd) => (
          <div key={wd} className="tw-text-xs tw-text-gray-400 tw-text-center tw-mb-1">{wd}</div>
        ))}
        {daysArray.map((dateObj, idx) => {
          if (!dateObj) {
            return <div key={idx} className="tw-h-10" />;
          }
          const entry = getEntryForDate(dateObj);
          const color = getHydrationColor(entry);
          const dd = dateObj.getDate().toString().padStart(1, "0");
          return (
            <div key={idx} className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-10">
              <div className={`tw-rounded-full tw-w-3 tw-h-3 tw-min-h-3 tw-min-w-3 tw-max-w-3 ${color}`}></div>
              <span className="tw-mt-1 tw-text-xs tw-text-gray-500">{dd}</span>
            </div>
          );
        })}
      </div>
      <div className="tw-flex tw-gap-4 tw-mt-4 tw-text-xs tw-px-2 tw-border-t tw-pt-4 tw-border-gray-200">
        <span className="tw-flex tw-items-center"><span className="tw-inline-block tw-w-3 tw-h-3 tw-bg-green-500 tw-rounded-full tw-mr-1"></span>Complete</span>
        <span className="tw-flex tw-items-center"><span className="tw-inline-block tw-w-3 tw-h-3 tw-bg-yellow-500 tw-rounded-full tw-mr-1"></span>Partial</span>
      </div>
    </div>
  );
};

export default MonthlyLog; 